import ManagerRepository from 'coreClasses/ManagerRepository';
import {CustomerProductListItem} from 'coreStore/data/customerProductLists/types';
import WishlistProductItemModel from './WishlistProductItemModel';

interface IWishlistInfo {
	items: CustomerProductListItem[];
}

/**
 * Represents WishlistInfoModel
 */
export default class WishlistInfoModel {
	public wishlistQuantity: number;
	public wishlistValue: number;
	public wishlistProducts: WishlistProductItemModel[];

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {object} wishlist - wishlist
	 */
	constructor(managerRepository: ManagerRepository, wishlist: IWishlistInfo) {
		const wishlistProducts: WishlistProductItemModel[]  = wishlist.items.map((productListItem) => {
			return {...new WishlistProductItemModel(managerRepository, productListItem)};
		});

		const wishlistTotal: number = wishlistProducts.reduce(
			(accumulator: number, currentProductItem: WishlistProductItemModel) => {
				return accumulator + currentProductItem.price;
			}, 0);

		this.wishlistQuantity = wishlistProducts.length;
		this.wishlistValue = wishlistTotal;
		this.wishlistProducts = wishlistProducts;
	}
};
